const chartPeriodoDinamico = {
  chart: {
    id: "sub-chart",
    fontFamily: "Roboto,Helvetica, Arial, sans-serif",
    toolbar: {
      show: true,
      offsetY: 10,
      offsetX: -10,
      tools: {
        download: false,
        selection: false,
        zoom: true,
        zoomin: true,
        zoomout: true,
        pan: false,
        reset: true
      }
    },
    zoom: {
      enabled: true,
      // autoScaleYaxis: true,
      type: "x"
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: "14px"
    }
  },
  grid: {
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  stroke: {
    width: [1, 0, 0, 1.5, 2, 2, 2, 2],
    curve: "smooth"
  },
  plotOptions: {
    bar: {
      columnWidth: "70%"
    }
  },
  fill: {
    opacity: [0.2, 1, 1, 0.2, 1, 1, 1]
  },
  labels: [],
  markers: {
    size: 0
  },
  xaxis: {
    labels: {
      formatter: function(val) {
        if (val) {
          const dt = val.split("-");
          return `${dt[2]}/${dt[1]}/${dt[0]}`;
        }
      }
    }
  },
  yaxis: {
    showAlways: true,
    forceNiceScale: true,
    labels: {
      formatter: val => {
        return formatarValor(val);
      }
    }
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: {
      format: "dd/MM/yyyy"
    },
    y: {
      formatter: function(val) {
        return new Intl.NumberFormat("pt-BR", {
          style: "decimal",
          maxDigits: 4,
          minimumFractionDigits: 4
        }).format(val);
      }
    }
  },
  legend: {
    show: true,
    position: "top",
    horizontalAlign: "center",
    offsetY: 18,
    markers: {
      radius: 1
    }
  }
};

const chartMensal = {
  chart: {
    id: "geral",
    type: "area",
    fontFamily: "Roboto,Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    },
    zoom: {
      enabled: true
      // autoScaleYaxis: true
    },
    brush: {
      enabled: true,
      target: "sub-chart"
      // autoScaleYaxis: true
    },
    selection: {
      enabled: true,
      type: "x",
      xaxis: {
        min: undefined,
        max: undefined
      }
    },
    events: {
      selection: undefined
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: "14px"
    }
  },
  grid: {
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  stroke: {
    width: 1.2,
    curve: "smooth"
  },
  fill: {
    opacity: [0.3, 0]
  },
  labels: [],
  markers: {
    size: 0
  },
  xaxis: {
    type: "datetime",
    labels: {
      format: "MM/yyyy"
    }
  },
  yaxis: {
    title: {
      text: "Saídas"
    },
    tickAmount: 4,
    labels: {
      formatter: val => {
        return formatarValor(val);
      }
    }
  },
  tooltip: {
    shared: false
  },
  legend: {
    show: false
  }
};

const chartTempoRessuprimento = {
  chart: {
    id: "tempo_ress",
    type: "area",
    fontFamily: "Roboto,Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    },
    zoom: {
      enabled: false
    },
    defaultLocale: "en",
    locales: [
      {
        name: "en",
        options: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro"
          ]
        }
      }
    ]
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      fontSize: "14px"
    }
  },
  grid: {
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    }
  },
  stroke: {
    width: 1.2,
    curve: "smooth"
  },
  fill: {
    opacity: [0.3]
  },
  labels: [],
  markers: {
    size: 0
  },
  xaxis: {
    type: "datetime",
    labels: {
      format: "MM/yyyy"
    }
  },
  yaxis: {
    title: {
      text: "Ressuprimento"
    },
    tickAmount: 3,
    min: 0,
    labels: {
      formatter: val => {
        return formatarValor(val);
      }
    }
  },
  dataLabels: {
    enabled: false
  },
  tooltip: {
    x: {
      show: true,
      format: "MMMM yyyy",
      formatter: undefined
    }
  },
  legend: {
    show: false
  }
};

function formatarValor(n) {
  var ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" }
  ];

  for (var i = 0; i < ranges.length; i++) {
    if (Math.abs(n) >= ranges[i].divider) {
      return (
        (Math.round(n) / ranges[i].divider).toFixed(1).toString() +
        ranges[i].suffix
      );
    }
  }

  if (n == null) {
    n = "0.00";
  }

  return parseInt(n);
}

export {
  chartPeriodoDinamico,
  chartMensal,
  chartTempoRessuprimento,
  formatarValor
};
